import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "w-50" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RoomAndRoomObjects = _resolveComponent("RoomAndRoomObjects")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.subTitle), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("strong", null, _toDisplayString(_ctx.selectedRoomObjectsCount), 1),
      _createTextVNode(" " + _toDisplayString(_ctx.$t("AppResource.DevicesSelected", [
                    _ctx.$t(`AppResource.${_ctx.RoomObjectType[_ctx.commandGroup.roomObjectType]}`),
                ])), 1)
    ]),
    _createVNode("div", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.contextualRoomObjects, (room, index) => {
        return (_openBlock(), _createBlock("div", { key: index }, [
          _createVNode(_component_RoomAndRoomObjects, {
            room: room,
            "room-object-type": _ctx.commandGroup.roomObjectType,
            "selected-roomobject": _ctx.selectedRoomObjects,
            onToggleRoomobject: _ctx.doToggleRoomObject
          }, null, 8, ["room", "room-object-type", "selected-roomobject", "onToggleRoomobject"])
        ]))
      }), 128))
    ])
  ]))
}